import { configureStore } from '@reduxjs/toolkit';

import { customerReducer } from './reducers/customerReducer';
import { notificationReducer } from './reducers/notificationReducer';
import { crawlerReducer } from './reducers/crawlerReducer';
import { releaseComponentReducer } from './reducers/releaseReducers/releaseComponentReducer';
import { releaseEnvironmentReducer } from './reducers/releaseReducers/releaseEnvironmentReducer';
import { releaseTaskReducer } from './reducers/releaseReducers/releaseTaskReducer';
import { menuCategoryReducer } from './reducers/menuCategoryReducer';
import { apiKeyTemplateReducer } from './reducers/apiKeyTemplateReducer';
import { loaderReducer } from './reducers/loaderReducer';

export const store = configureStore({
  reducer: {
    /** 顧客管理画面の状態 */
    customer: customerReducer,
    /** お知らせ管理画面の状態 */
    notification: notificationReducer,
    /** クローラー管理画面の状態 */
    crawler: crawlerReducer,
    /** APIキーテンプレートの状態 */
    apiKeyTemplate: apiKeyTemplateReducer,
    /** リリース管理画面コンポーネントの状態 */
    releaseComponent: releaseComponentReducer,
    /** リリース管理画面環境の状態 */
    releaseEnvironment: releaseEnvironmentReducer,
    /** リリース管理画面タスクの状態 */
    releaseTask: releaseTaskReducer,
    /** メニュー管理画面の状態 */
    menuCategory: menuCategoryReducer,
    /** ローダ管理画面の状態 */
    loader: loaderReducer,
  },
});

// store 自身から `RootState` と `AppDispatch` の型を推論する
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
